import { useState, useEffect } from 'react';
import { resolveApiBaseUrl } from '@/config/apiBase';
import { logger } from '@/lib/logger';

export const useBackendStatus = () => {
  const [isBackendOnline, setIsBackendOnline] = useState(true);
  const [lastCheck, setLastCheck] = useState(Date.now());

  const checkBackendHealth = async () => {
    const baseUrl = resolveApiBaseUrl();
    const endpoints = ['/health', '/health/plain', '/docs'];
    
    for (const endpoint of endpoints) {
      try {
        logger.debug('Verificando estado del backend:', `${baseUrl}${endpoint}`);
        
        const response = await fetch(`${baseUrl}${endpoint}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          // Timeout de 10 segundos para producción
          signal: AbortSignal.timeout(10000),
          // Añadir mode para CORS
          mode: 'cors'
        });
        
        logger.debug('Respuesta del health check:', response.status, response.statusText);
        
        if (response.ok) {
          const data = await response.text();
          logger.debug('Backend online:', data);
          setIsBackendOnline(true);
          setLastCheck(Date.now());
          return; // Si uno funciona, salir del bucle
        } else {
          logger.debug('Backend respondió con error:', response.status);
        }
      } catch (error) {
        logger.debug('Endpoint no disponible:', endpoint, error.message);
        // Continuar con el siguiente endpoint
      }
    }
    
    // Si llegamos aquí, ningún endpoint funcionó
    logger.warn('Todos los endpoints fallaron, backend offline');
    
    setIsBackendOnline(false);
  };

  useEffect(() => {
    // Verificar al montar el componente
    checkBackendHealth();

    // Verificar cada 30 segundos
    const interval = setInterval(checkBackendHealth, 30000);

    return () => clearInterval(interval);
  }, []);

  const retryConnection = () => {
    checkBackendHealth();
  };

  return {
    isBackendOnline,
    lastCheck,
    retryConnection,
    checkBackendHealth
  };
};
